import * as React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Typography,
    Popover,
    Button,
    IconButton,
    OutlinedInput
} from '@mui/material';
import { Box, Stack } from '@mui/system';
import MainCard from 'ui-component/cards/MainCard';
import axiosServices from 'utils/axios';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import useAuth from 'hooks/useAuth';
import { Icon } from '@iconify/react';
import { dispatch, globalAction } from 'store';
import { useNavigate, useSearchParams } from 'react-router-dom';

const NotificationList = () => {
    const [searchParams] = useSearchParams();
    const pageNumber = searchParams.get('page');
    const { user } = useAuth();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [notificationList, setNotificationList] = React.useState([]);
    const [page, setPage] = React.useState(1);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [totalCount, setTotalCount] = React.useState(0);
    const [notoficationId, setNotificationId] = React.useState(null);
    const [path, setPath] = React.useState(null);
    const [readStatus, setReadStatus] = React.useState(null);
    const [search, setSearch] = React.useState('');
    const handleClick = (event, data) => {
        setAnchorEl(event.currentTarget);
        setNotificationId(data?.id);
        setPath(data?.path);
        setReadStatus(data?.readStatus);
        console.log(data);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const zeroBasedPage = page - 1;

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const getAllNotifications = async (pageNumber = 1, limit = 10) => {
        try {
            const response = await axiosServices.get(`/api/notifications?page=${pageNumber}&limit=${limit}&search=${search}`);
            setNotificationList(response?.data?.data || []);
            setTotalCount(response?.data?.total || 0);
        } catch (error) {
            dispatch(globalAction('SHOW_TOASTER', { status: 'error', message: error?.message }));
        }
    };
    const readAllNotifications = () => {
        try {
            axiosServices.put(`/api/notifications/read-notification/${user?.id}`).then((res) => {
                if (res?.data?.status === 'success') {
                    getAllNotifications(page, rowsPerPage);
                    dispatch(globalAction('SHOW_TOASTER', { status: 'success', message: res?.data?.message }));
                }
            });
        } catch (error) {
            dispatch(globalAction('SHOW_TOASTER', { status: 'error', message: error?.message }));
        }
    };

    React.useEffect(() => {
        getAllNotifications(page, rowsPerPage);
    }, [page, rowsPerPage, search]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage + 1);
        navigate(`?page=${newPage + 1}`);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };
    const handleDeleteNotification = () => {
        try {
            axiosServices.delete(`/api/notifications/${notoficationId}`).then((res) => {
                if (res?.data?.status === 'success') {
                    getAllNotifications(page, rowsPerPage);
                    dispatch(globalAction('SHOW_TOASTER', { status: 'success', message: res?.data?.message }));
                }
            });
        } catch (error) {
            dispatch(globalAction('SHOW_TOASTER', { status: 'error', message: error?.message }));
        } finally {
            setNotificationId(null);
            setPath(null);
            handleClose();
            setReadStatus(null);
        }
    };
    const readNotification = (item) => {
        navigate(`/${item?.path}`);
        if (item.readStatus) return;
        try {
            axiosServices.patch(`/api/notifications/read-notification/${item?.id}`);
        } catch (error) {
            dispatch(globalAction('SHOW_TOASTER', { status: 'error', message: error?.message }));
        }
    };
    const handlePath = () => {
        navigate(`/${path}`);
        if (readStatus) return;
        try {
            axiosServices.patch(`/api/notifications/read-notification/${notoficationId}`);
        } catch (error) {
            dispatch(globalAction('SHOW_TOASTER', { status: 'error', message: error?.message }));
        } finally {
            setPath(null);
            setReadStatus(null);
            setNotificationId(null);
            handleClose();
        }
    };
    React.useEffect(() => {
        if (pageNumber) {
            setPage(Number(pageNumber));
        }
    }, [pageNumber]);

    const handleSearch = (value) => {
        navigate('?page=1');
        setSearch(value);
    };

    return (
        <MainCard
            title={<Typography variant="h3">All Notifications</Typography>}
            content={false}
            secondary={
                <Button variant="contained" onClick={readAllNotifications}>
                    Mark all read
                </Button>
            }
        >
            <Box
                sx={{
                    p: 1,
                    my: 1
                }}
            >
                <OutlinedInput
                    id="Search"
                    type="text"
                    name="Search"
                    aria-describedby="outlined-weight-helper-text"
                    placeholder="Search..."
                    size="small"
                    value={search}
                    onChange={(e) => handleSearch(e.target.value)}
                />
            </Box>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Title</TableCell>
                            <TableCell>Sub Title</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {notificationList.map((notif, i) => (
                            <TableRow
                                key={notif.id}
                                sx={{
                                    background: notif?.readStatus ? '#fff' : 'rgba(245, 245, 245, 0.61)'
                                }}
                            >
                                <TableCell>{i + 1}</TableCell>
                                <TableCell
                                    onClick={() => readNotification(notif)}
                                    sx={{
                                        cursor: 'pointer'
                                    }}
                                >
                                    {notif.title}
                                </TableCell>
                                <TableCell>{notif.subTitle}</TableCell>
                                <TableCell>{new Date(notif.createdAt).toLocaleDateString()}</TableCell>
                                <TableCell align="right">
                                    <IconButton onClick={(e) => handleClick(e, notif)} aria-label="Action">
                                        <MoreVertIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    component="div"
                    count={totalCount}
                    page={zeroBasedPage}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[5, 10, 25]}
                />
            </TableContainer>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <Stack direction="column" sx={{ minWidth: 104, py: 2 }}>
                    <Button color="primary" sx={{ justifyContent: 'flex-start', alignItems: 'center', gap: 1 }} onClick={handlePath}>
                        <Icon icon="hugeicons:view" fontSize={18} />
                        View
                    </Button>
                    <Button
                        color="error"
                        sx={{ justifyContent: 'flex-start', alignItems: 'center', gap: 1 }}
                        onClick={handleDeleteNotification}
                    >
                        <Icon icon="fluent:delete-28-regular" fontSize={18} />
                        Delete
                    </Button>
                </Stack>
            </Popover>
        </MainCard>
    );
};

export default NotificationList;
